module.exports = __webpack_public_path__ + "assets/img/00041.e8ed1d4a.png";